import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  Switch,
  FormControlLabel,
  Slide,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import { handleGoogleLogin } from "../services/authService";
import InAppBrowserModal from "./InAppBrowserModal";

const bottomSheetStyle = {
  position: 'fixed',
  bottom: 0,
  left: '50%',
  transform: 'translateX(-50%)',
  margin: 0,
  maxHeight: '50vh',
  borderRadius: '16px 16px 0 0',
  width: '100%',
  maxWidth: '600px',
  transition: 'transform 0.3s ease-out',
  '&.MuiDialog-root': {
    '& .MuiDialog-paper': {
      transform: 'translateY(100%)',
      transition: 'transform 0.3s ease-out',
    },
    '&.MuiDialog-open': {
      '& .MuiDialog-paper': {
        transform: 'translateY(0)',
      },
    },
  },
};

const SnapFollowBottomSheet = ({ open, onClose, targetName, onFollow, isFollowing, isLoggedIn }) => {
  const [hideForToday, setHideForToday] = useState(false);
  const [inAppBrowserModalOpen, setInAppBrowserModalOpen] = useState(false);
  const theme = useTheme();

  const handleClose = () => {
    if (hideForToday) {
      const today = new Date().toISOString().split('T')[0];
      localStorage.setItem('hideSnapFollowPrompt', today);
    }
    onClose();
  };

  const handleFollowClick = async () => {
    if (!isLoggedIn) {
      try {
        await handleGoogleLogin(
          // 성공 콜백
          async (user) => {
            if (user) {
              // 로그인 성공 후 팔로우 실행
              await onFollow();
              handleClose(); // 팔로우 성공 후 바텀시트 닫기
            }
          },
          // 오류 콜백
          (error) => {
            console.error("로그인 오류:", error);
          },
          // 인앱 브라우저 감지 콜백
          () => {
            setInAppBrowserModalOpen(true);
          }
        );
      } catch (error) {
        console.error("로그인 프로세스 오류:", error);
      }
      return;
    }
    
    // 로그인 상태에서 팔로우 실행
    await onFollow();
    handleClose(); // 팔로우 성공 후 바텀시트 닫기
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      PaperProps={{ sx: bottomSheetStyle }}
      TransitionComponent={Slide}
      TransitionProps={{ direction: 'up' }}
      keepMounted
    >
      <Box sx={{ 
        p: 3, 
        bgcolor: theme.palette.background.paper,
        borderRadius: '16px 16px 0 0',
      }}>
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 12,
            top: 12,
            color: theme.palette.text.secondary,
          }}
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 600,
              fontSize: '1.1rem',
              mb: 2,
              color: theme.palette.text.primary,
            }}
          >
            스냅리스트 추가
          </Typography>

          <Typography 
            variant="body1" 
            sx={{ 
              fontWeight: 500, 
              textAlign: 'center', 
              mb: 1,
              color: theme.palette.text.primary,
              fontSize: '1.05rem',
              lineHeight: 1.6,
            }}
          >
            {targetName}님을 스냅리스트 추가해 보세요.<br />
          </Typography>

          <Typography 
            variant="body2" 
            sx={{ 
              color: theme.palette.text.secondary, 
              textAlign: 'center',
              fontSize: '0.90rem',
              mb: 3,
            }}
          >
            상대방은 당신을 확인할 수 없어요.
          </Typography>

          <Button
            variant="contained"
            fullWidth
            onClick={handleFollowClick}
            disabled={isFollowing}
            sx={{
              bgcolor: theme.palette.mode === 'dark' ? 'grey.800' : 'grey.900',
              color: 'white',
              py: 1.5,
              fontSize: '1.05rem',
              fontWeight: 500,
              borderRadius: 2,
              '&:hover': {
                bgcolor: theme.palette.mode === 'dark' ? 'grey.700' : 'grey.800',
              },
              '&.Mui-disabled': {
                bgcolor: theme.palette.mode === 'dark' ? 'grey.700' : 'grey.300',
                color: theme.palette.mode === 'dark' ? 'grey.500' : 'grey.600',
              },
            }}
          >
            {isFollowing ? '스냅리스트에 추가됨' : '스냅리스트에 추가'}
          </Button>
        </Box>

        <Box 
          onClick={() => {
            setHideForToday(true);
            handleClose();
          }}
          sx={{ 
            width: '100%',
            textAlign: 'center',
            cursor: 'pointer',
            mt: 1,
            py: 1,
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ 
              color: theme.palette.text.secondary,
              fontSize: '0.9rem',
              '&:hover': {
                color: theme.palette.text.primary,
              },
            }}
          >
            하루 동안 다시 보지 않기
          </Typography>
        </Box>
      </Box>

      <InAppBrowserModal 
        open={inAppBrowserModalOpen} 
        onClose={() => setInAppBrowserModalOpen(false)} 
      />
    </Dialog>
  );
};

export default SnapFollowBottomSheet; 